module.exports = __webpack_public_path__ + "static/media/sx.522d898c.svg";